import api from '../services/api';

const ProductoPublicModel = {
    // Obtener todos los productos activos
    getAll: async () => {
        try {
            const response = await api.get('/productos');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo productos:', error);
            return [];
        }
    },

    // Obtener producto por ID
    getById: async (id) => {
        try {
            const response = await api.get(`/productos/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error obteniendo producto:', error);
            return null;
        }
    },

    // Obtener productos por categoría
    getByCategoria: async (categoria) => {
        try {
            const response = await api.get(`/productos?categoria=${categoria}`);
            return response.data;
        } catch (error) {
            console.error('Error obteniendo productos por categoría:', error);
            return [];
        }
    },

    // Obtener productos destacados
    getDestacados: async () => {
        try {
            const response = await api.get('/productos?destacados=true');
            return response.data;
        } catch (error) {
            console.error('Error obteniendo productos destacados:', error);
            return [];
        }
    }
};

export default ProductoPublicModel;